import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
    className: PropTypes.string,
    isRemove: PropTypes.bool,
};

const defaultProps = {
    className: null,
    isRemove: false,
};

const AddToCalendar = ({ className, isRemove }) =>
    isRemove ? (
        // CALENDAR WITH MINUS PILL ICON
        // <svg
        //     className={classNames([
        //         {
        //             [className]: className !== null,
        //         },
        //     ])}
        //     id="a"
        //     xmlns="http://www.w3.org/2000/svg"
        //     viewBox="0 0 32.63 30.56"
        // >
        //     <g id="b">
        //         <g id="c">
        //             <path
        //                 id="d"
        //                 d="M1.04,19.84c-.58,0-1.04-.47-1.04-1.04V1.04C0,.47,.47,0,1.04,0H20.9c.58,0,1.04,.47,1.04,1.04V12.22c0,.58-5.96,7.64-6.54,7.64H1.04Zm.96-2.01H14.74c.47-.46,1.38-1.43,2.67-2.94,1.3-1.53,2.18-2.66,2.54-3.19V4.83c-.25,.11-.53,.17-.81,.17H2v12.84Z"
        //                 fill="currentColor"
        //             />
        //             <path
        //                 id="e"
        //                 d="M2.13,2.01c-.55,0-1,.45-1,1s.45,1,1,1H19.13c.55,0,1-.45,1-1s-.45-1-1-1H2.13m0-1H19.13c1.1,0,2,.9,2,2s-.9,2-2,2H2.13C1.03,5.01,.13,4.11,.13,3.01S1.03,1.01,2.13,1.01Z"
        //                 fill="currentColor"
        //             />
        //         </g>
        //         <path
        //             id="f"
        //             d="M23,30.56c-5.32,0-9.63-4.31-9.63-9.63s4.31-9.63,9.63-9.63,9.63,4.31,9.63,9.63c0,5.31-4.31,9.62-9.63,9.63Zm-4.81-10.58v1.91h9.62v-1.91h-9.62Z"
        //             fill="currentColor"
        //         />
        //     </g>
        // </svg>
        // REGULAR CALENDAR ICON
        <svg className={className} id="a" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 19">
            <path
                id="b"
                d="M1,19c-.55,0-1-.45-1-1V1C0,.45,.45,0,1,0H20c.55,0,1,.45,1,1V18c0,.55-.45,1-1,1H1Zm1-2H19V4.73c-.3,.18-.65,.27-1,.27H2v12Z"
                fill="currentColor"
            />
        </svg>
    ) : (
        <svg
            className={classNames([
                {
                    [className]: className !== null,
                },
            ])}
            id="a"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32.63 30.56"
        >
            <g id="b">
                <g id="c">
                    <path
                        id="d"
                        d="M1.04,19.84c-.58,0-1.04-.47-1.04-1.04V1.04C0,.47,.47,0,1.04,0H20.9c.58,0,1.04,.47,1.04,1.04V12.22c0,.58-5.96,7.64-6.54,7.64H1.04Zm.96-2.01H14.74c.47-.46,1.38-1.43,2.67-2.94,1.3-1.53,2.18-2.66,2.54-3.19V4.83c-.25,.11-.53,.17-.81,.17H2v12.84Z"
                        fill="currentColor"
                    />
                    <path
                        id="e"
                        d="M2.13,2.01c-.55,0-1,.45-1,1s.45,1,1,1H19.13c.55,0,1-.45,1-1s-.45-1-1-1H2.13m0-1H19.13c1.1,0,2,.9,2,2s-.9,2-2,2H2.13C1.03,5.01,.13,4.11,.13,3.01S1.03,1.01,2.13,1.01Z"
                        fill="currentColor"
                    />
                </g>
                <path
                    id="f"
                    d="M23,30.56c-5.32,0-9.63-4.31-9.63-9.63s4.31-9.63,9.63-9.63,9.63,4.31,9.63,9.63c0,5.31-4.31,9.62-9.63,9.63Zm-4.81-10.58v1.91h3.85v3.85h1.91v-3.85h3.85v-1.91h-3.85v-3.85h-1.91v3.85h-3.85Z"
                    fill="currentColor"
                />
            </g>
        </svg>
    );

AddToCalendar.propTypes = propTypes;
AddToCalendar.defaultProps = defaultProps;

export default AddToCalendar;
